import { render, staticRenderFns } from "./resources_management.vue?vue&type=template&id=d8032b20&scoped=true"
import script from "./resources_management.vue?vue&type=script&lang=js"
export * from "./resources_management.vue?vue&type=script&lang=js"
import style0 from "./resources_management.vue?vue&type=style&index=0&id=d8032b20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8032b20",
  null
  
)

export default component.exports